export default "__VITE_ASSET__BrDZieQ9__"